<style scoped>
:deep() .vs__selected-options {
  flex-wrap: nowrap !important;
}
:deep() .form-holder ul li.noColor input.vs__search {
  border-color: transparent;
}
:deep() .vs__dropdown-toggle {
  border: 1px solid #28485e;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<template>
  <div class="content-holder">
    <div v-if="porPopup">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-left">
                <p>{{$t("withdrawal.kyc_req_msg")}}
                  <router-link :to="{ path:'/ticket-details', query : { id: store.user.profile.ticket_id }}" v-if="store.user.profile.ticket_id">{{$t("withdrawal.click_here")}}</router-link>
                  {{$t("withdrawal.or_email_to")}} <a href="mailto:contactus@aaafx.com">contactus@aaafx.com</a>
                </p>
                <p>{{$t("withdrawal.with_step_heading")}}:</p>
                <p>{{$t("withdrawal.one")}}. {{$t("withdrawal.with_step_one")}}</p>
                <p>{{$t("withdrawal.two")}}. {{$t("withdrawal.with_step_two")}}</p>
                <p>{{$t("withdrawal.three")}}. {{$t("withdrawal.with_step_three")}}</p>
                <p><strong>{{$t("withdrawal.note")}}:</strong> {{$t("withdrawal.note_info")}}. </p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="porPopup = false" v-if="store.user.verified_status">{{$t("withdrawal.ok")}} </a>
                <router-link to="/dashboard" class="btn btn-lblue close-popup" v-else>{{$t("withdrawal.ok")}} </router-link>
              </div>
              <button title="Close (Esc)" type="button" class="mfp-close" @click.prevent="porPopup = false">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="store.user.profile.gAuthenticatorEnabled != 1">
      <div v-if="!showAuth">
        <p class="text-center">{{$t("withdrawal.enable_2fa_msg")}}</p>
        <div class="btn-holder t-center"><button type="submit" class="btn btn-yellow popup-link-holder" @click.stop="showAuth = true">{{$t("withdrawal.click_to_enable")}}</button></div>
      </div>
      <TwoFaEnable v-else></TwoFaEnable>
    </div>
    <div v-else>
      <div class="form-holder acct-transfer">
        <ul class="clearfix">
          <li class="f-left">
            <label for="">{{$t("withdrawal.select_trading_id")}}</label>
            <div class="drop-search">
              <!-- <AccountsDropdown  :onlyLive = "true" /> -->
              <select class="form-control" name="account" v-model="store.lastSelectedAccount.account_id"  @change="GetTradingAccountDetail">
                <option value="" label="Select Trading ID">{{$t("withdrawal.select_trading_id")}}</option>
                <optgroup label="Live MT4">
                  <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT4')" :key ="index" >{{list.account_id}}</option>
                </optgroup>
                <optgroup label="Live MT5">
                  <option :value="list.account_id" v-for="list,index in MergeAcc('1','MT5')" :key ="index" >{{list.account_id}}</option>
                </optgroup>
                <optgroup label="Live ZTP">
                  <option :value="list.account_id" v-for="list,index in MergeAcc('1','ZTP')" :key ="index" >{{list.account_id}}</option>
                </optgroup>
            </select>
            </div>
          </li>
        </ul>
      </div>
      <div class="table-holder table-holder4 t-center">
        <table>
          <tr>
            <th>{{$t("withdrawal.account_id")}}</th>
            <th>{{$t("withdrawal.account_type")}}</th>
            <th>{{$t("withdrawal.platform")}}</th>
            <th>{{$t("withdrawal.leverage")}}</th>
            <th>{{$t("withdrawal.currency")}}</th>
            <th>{{$t("withdrawal.free_margin")}}</th>
          </tr>
          <tr>
            <td>{{ store.lastSelectedAccount.account_id }}</td>
            <td>{{ store.lastSelectedAccount.account_type }}</td>
            <td>{{ store.lastSelectedAccount.platform }}</td>
            <td>{{ store.lastSelectedAccount.leverage || 'X'}}</td>
            <td>{{ store.lastSelectedAccount.currency }}</td>
            <td>
              {{
                COMMON.priceWithCurrency(
                  store.lastSelectedAccount,
                  store.tradingAccountDetail.margin_detail.freeMargin
                )
              }}
            </td>
          </tr>
        </table>
      </div>
      <div class="note">
        <p>{{$t("withdrawal.note")}}: {{$t("withdrawal.note_info_two")}}</p>
      </div>
      <div class="form-holder widthraw-form">
        <Form @submit="submit">
          <ul class="clearfix" data-select2-id="9">
            <li class="half-width f-left">
              <label for="">{{$t("withdrawal.amount")}}</label>
              <div>
                <Field
                  type="number"
                  name="amount"
                  :rules="(store.lastSelectedAccount.platform != 'ZTP') ? 'required':''"
                  v-model="store.withdrawalAmount"
                />
              </div>
              <ErrorMessage name="amount" />
            </li>
            <!-- //change the condition to == 1 -->
            <li class="half-width f-right" v-if="parseInt(store.lastSelectedAccount.demo_live) == 1">
              <label for="">{{$t("withdrawal.mode_of_payment")}}</label>
              <Field
                class="form-control"
                as="select"
                name="payment mode"
                rules="required"
                v-model="form.method_type"
              >
                <option value="" disabled>{{$t("withdrawal.mode_of_payment")}}</option>
                <option v-for="item in withoutBankData" :key="item.id" :value="item.id">{{item.name}}</option>
                  <optgroup :label="static_vars.withdrawalMethod[key]" v-for="value,key in getBankData" :key="key">
                    <option :value="key+'-'+list.id" v-for="list in value" :key ="list.id">
                      <!-- {{(list.online_payment_id != '') ? list.online_payment_id : (list.last_digit_card != '') ? `XXXXXXXXXXXX${list.last_digit_card.slice(-4)}` : `XXXXXXXXXXXX${list.account_no.slice(-4)}`}} -->
                      {{(list.online_payment_id != '') ? list.online_payment_id : (list.last_digit_card != '') ? `XXXXXXXXXXXX${list.last_digit_card.slice(-4)}` : `XXXXXXXXXXXX${list.account_no.slice(-4)}`}}
                    </option>
                  </optgroup>
              </Field>
              <ErrorMessage name="payment mode" />
            </li>
          </ul>
          <div class="btn-holder t-left">
            <button class="btn btn-yellow popup-link-holder" :disabled="(  Object.keys(store.tradingAccountDetail.margin_detail).length == 0 ||    COMMON.convertStringToInteger(     store.tradingAccountDetail.margin_detail.freeMargin   ) == 0) && store.lastSelectedAccount.platform != 'ZTP'" >
              {{$t("withdrawal.create_transaction")}}
            </button>
            <a href="#" class="btn btn-blue" @click.prevent="$parent.fundType = 'Deposits'">
              {{$t("withdrawal.cancel")}}
            </a>
            <router-link to="/add-payment-method" class="btn btn-blue" @click.prevent="$parent.fundType = 'Deposits'" >
              {{$t("withdrawal.add_payment_method")}}
            </router-link>
          </div>
          <span class="text-danger" v-if=" (Object.keys(store.tradingAccountDetail.margin_detail).length == 0 ||    COMMON.convertStringToInteger(     store.tradingAccountDetail.margin_detail.freeMargin   ) == 0) && store.lastSelectedAccount.platform != 'ZTP' ">
            {{$t("withdrawal.no_amount_available")}}
          </span>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { useMainStore } from "@/store";
//import AccountsDropdown from "@/components/shared/AccountsDropdown";
import moment from "moment";
import { Form, Field, ErrorMessage } from "vee-validate";
import TwoFaEnable from "../user/2fa-enable";

export default {
  name: "Home",
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      name: "withdrawal",
      form: {
        amount: "",
        method_type: "",
      },
      errorMsg: null,
      showAuth: false,
      porPopup: false,
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    TwoFaEnable
    //AccountsDropdown,
  },
  computed:{
    withoutBankData(){
      if(Object.keys(this.store.withdrawalMethods).length){
        let arr = [];
        for(let key in this.store.withdrawalMethods){
          if(parseInt(key) != 1 && parseInt(key) != 5 && parseInt(key) != 18){
            arr.push({'id' : key,'name' : this.static_vars.withdrawalMethod[key]})
          }
        }
        return arr
      }else{
        return []
      }
    },
    getBankData(){
        let obj = {};
        if(Object.keys(this.store.withdrawalMethods).length){
          for(let key in this.store.withdrawalMethods){
            if(parseInt(key) == 1 || parseInt(key) == 5 || parseInt(key) == 18){
              obj[key] = this.store.withdrawalMethods[key]
            }
          }
          return obj
        }else{
          return {}
        }
    },
    forUsers(){
      // return [4668].includes(this.store.user.profile.user_id) ; // dev
      return [20081,41322,40774].includes(this.store.user.profile.user_id) ; // live
    }
    // getCryptoData(){
    //     let obj = {};
    //     if(Object.keys(this.store.callCryptoMethodList).length){
    //       for(let key in this.store.callCryptoMethodList){

    //         if(parseInt(key) == 1 || parseInt(key) == 5){
    //           obj[key] = this.store.callCryptoMethodList[key]
    //         }
    //       }
    //       return obj
    //     }else{
    //       return {}
    //     }
    // },

  },
  methods: {
    MergeAcc(acc_type,platform){
        let demoMT4 = this.store.tradingAccounts.records.filter(i => i.demo_live == acc_type && i.platform == platform).map(val => val)
        return demoMT4 || []
    },
    GetTradingAccountDetail(e){
      let acct = this.store.tradingAccounts.records.find(
        (i) => i.account_id == e.target.value
      );
      let keys = {
        dataRequired: {
          margin_detail: true,
          open_trades: false,
          history: false,
          account_detail: false,
        },
      };
      this.store.setLastSelectedAccount(acct, keys,false,'');
    },
    submit() {
      if(this.store.user.por == 0 && this.forUsers){
        this.porPopup = true
        return;
      }
      let method = this.form.method_type.split("-")
      this.form.method_type = method[0]
      let method_id = method[1]
      //console.log(this.form.method_type,"----^^^------",method_id)
      if(this.store.lastSelectedAccount.platform != 'ZTP'){
        if (
        parseInt(this.store.tradingAccountDetail.margin_detail.freeMargin) > 0
      ) {
        if(parseInt(this.store.lastSelectedAccount.demo_live) == 1){
          // let data = Object.keys(this.static_vars.withdrawalMethod).filter(
          //   (val) => val == this.form.method_type
          // );
          let form = {
            account_id: this.store.lastSelectedAccount.account_id,
            act_account_id: this.store.lastSelectedAccount.act_account_id,
            amount: this.store.withdrawalAmount,
            method_id: method_id,
            operation: "WITHDRAWAL",
            withdrawal_method: this.form.method_type.toString(),
          };
          if([52,55,23].includes(parseInt(form.withdrawal_method))){
            form['currency'] = this.store.lastSelectedAccount.currency
            this.store.praxisWithdrawalRequest(form, true, this)
          }else{
            this.store.createWithdrawalRequest(form, true, this);
          }
        }else{
          let form = {
            account_id: this.store.lastSelectedAccount.account_id,
            act_account_id: this.store.lastSelectedAccount.act_account_id,
            amount: (-(this.store.withdrawalAmount)).toString(),
            comment : "withdraw",
            operation: "WITHDRAWAL",
          };
          this.store.startDemoFunding(form, true,this).then(() => {
             //this.store.$patch({ withdrawalAmount: null });
          }).catch(() => {
          //this.store.$patch({ withdrawalAmount: null });
        })
        }
      } else {
        this.errorMsg = "";
      }
      }else{
        let form = {
          account_id: this.store.lastSelectedAccount.account_id,
          act_account_id: this.store.lastSelectedAccount.act_account_id,
          amount: this.store.withdrawalAmount || 0,
          method_id: method_id,
          operation: "WITHDRAWAL",
          withdrawal_method: this.form.method_type.toString(),
        };
        if([52,55,23].includes(parseInt(form.withdrawal_method))){
          form['currency'] = this.store.lastSelectedAccount.currency
          this.store.praxisWithdrawalRequest(form, true, this)
        }else{
          this.store.createWithdrawalRequest(form, true, this);
        }
      }
    },
    selectTradingAccount(e) {
      this.store.setLastSelectedAccount(e);
    },
    timeFunc(getData) {
      return moment.unix(getData).format("Do MMM, YYYY HH:mm:ss");
    },
  },
  created(){
    this.store.callWithdrawalMethodList({},true)
  },
  mounted(){
    this.showAuth = false
  }
};
</script>
